enum DayGridScenario {
    TimePanelDayView,
    TimePanelConflictsView,
    RSVPPeek,
    MailCalendarCard,
}

export default DayGridScenario;
